export default "__VITE_ASSET__BywyfvWi__"